import { Icons, Sizes, Text } from '@sede-enterprise/shell-ds-react-framework';
import {
  CompanyNotFoundIcon,
  CompanyNotFoundWrapper,
} from 'components/CompanyList/CompanyList.styled';

const { SearchFailed } = Icons;

export const NoDataFound = () => {
  return (
    <CompanyNotFoundWrapper>
      <CompanyNotFoundIcon>
        <SearchFailed />
      </CompanyNotFoundIcon>

      <Text type="p" size={Sizes.Medium} bold style={{ marginBottom: 8 }}>
        Nothing found...
      </Text>
      <Text type="p" size={Sizes.Small}>
        Try another search criteria
      </Text>
    </CompanyNotFoundWrapper>
  );
};
